import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";
import { QuerySupplierOfficesOrderByColumn, SortOrder } from "@/gql/graphql";

export type SupplierOfficeListItem = ResultOf<
  typeof supplierOfficeListQuery
>["supplierOffices"]["data"][number];

// Single source of the office-list variables so the route loader, the offices
// screen and the trip matrix all resolve to the exact same react-query key.
export function supplierOfficeListVariables(supplierId: string) {
  return {
    page: 1,
    archived: false,
    supplier_id: supplierId,
    first: 200,
    orderBy: [
      {
        column: QuerySupplierOfficesOrderByColumn.Name,
        order: SortOrder.Asc,
      },
    ],
  };
}

export const supplierOfficeListQuery = graphql(`
  query SupplierOfficeList(
    $first: Int!
    $page: Int
    $search: String
    $supplier_id: ID
    $orderBy: [QuerySupplierOfficesOrderByRelationOrderByClause!]
    $archived: Boolean
  ) {
    supplierOffices(
      first: $first
      page: $page
      search: $search
      supplier_id: $supplier_id
      orderBy: $orderBy
      archived: $archived
    ) {
      data {
        id
        name
        code
        address {
          id
          lat
          lng
          address_line_1
          address_line_2
          formatted_address_line_1
          formatted_address_line_2
          postcode
          city
          state
          country
          locationMedia {
            ...MediaFields
          }
        }
        city {
          id
          name
          region
          state
        }
        created_at
        updated_at
        supplier {
          id
          name
          hire_unit_type
          measurement
          currency
        }
        archived_at
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
